import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { ErrorPageLayout } from '../ErrorLayout/ErrorLayoutPage';

import { LoadingLayout } from './components/LoadingLayout';
import { OrganizationPreloadLayout } from './layouts/OrganizationPreloadLayout';

import { OrganizationsColorProvider } from '@/app/context/OrganizationsColorProvider';
import { loginRequest, msalInstance } from '@/services/msal';

export const AuthLayout = () => {
	return (
		<MsalProvider instance={msalInstance}>
			<MsalAuthenticationTemplate
				interactionType={InteractionType.Redirect}
				authenticationRequest={{
					...loginRequest,
				}}
				errorComponent={(error) => <ErrorPageLayout error={error} />}
				loadingComponent={LoadingLayout}
			>
				<OrganizationPreloadLayout>
					<OrganizationsColorProvider>
						<Outlet />
					</OrganizationsColorProvider>
				</OrganizationPreloadLayout>
				<ToastContainer
					bodyStyle={{ fontFamily: 'Graphik' }}
					progressStyle={{ background: '#fe3266' }}
				/>
			</MsalAuthenticationTemplate>
		</MsalProvider>
	);
};
